export default __webpack_public_path__ + "search-examples-mapbox-mapview-category-960-d51b98e7be164568d5d8007650ec931c.png";